import { useReactiveVar } from '@apollo/client';
import { useLocation } from '@hulu/react-router-dom';
import React, { useContext, useMemo } from 'react';

import useFetchUserByOrganization from '../../../../apis/graphql/user/useFetchUserByOrganization';
import { isBaymaxEnabledVar, selectedAdAccountIdVar, selectedOrganizationIdVar } from '../../../../constants';
import { GlobalPermissionsContext } from '../../../../context';
import CustomLink from '../../../CustomLink';
import { ROLES } from '../../../User/constants';
import { LINKS } from '../../constants';
import usePostLoginHeaderNavigate from '../../hooks/usePostLoginHeaderNavigate';
import { NavMenu, StyledLinkElement } from '../../styled';

const BrunoMenu = (): JSX.Element => {
  const { permissions } = useContext(GlobalPermissionsContext);
  const { pathname } = useLocation();
  const selectedAdAccountId = useReactiveVar(selectedAdAccountIdVar);
  const selectedOrganizationId = useReactiveVar(selectedOrganizationIdVar);
  const { data: loggedInUserData } = useFetchUserByOrganization(selectedOrganizationId);
  const isBaymaxEnabled = useReactiveVar(isBaymaxEnabledVar);

  const { handleClickToAdGallery, handleClickToCampaigns, handleClickToReports, handleClickToHamhub } =
    usePostLoginHeaderNavigate(pathname);

  const isCampaignButtonAvailable = useMemo(
    () => !loggedInUserData?.roleList?.some((item) => item.role === ROLES.manager) && selectedAdAccountId,
    [loggedInUserData?.roleList, selectedAdAccountId]
  );

  const baymaxAccountsOnly = isBaymaxEnabled && !selectedAdAccountId;

  return (
    <NavMenu data-testid="brunoNavigationMenu">
      {!!isCampaignButtonAvailable && (
        <StyledLinkElement
          onClick={(): void | boolean => {
            if (!baymaxAccountsOnly && permissions.GET_CAMPAIGN) {
              handleClickToCampaigns();
            }
          }}
          data-testid="campaignsLink"
          data-text="campaigns"
          $isSelected={pathname.includes('campaigns')}
          $disabled={!permissions.READ_CAMPAIGN_LINEITEMS || baymaxAccountsOnly}
        >
          campaigns
        </StyledLinkElement>
      )}
      <StyledLinkElement
        $disabled={!permissions.READ_REPORT}
        onClick={(): void => handleClickToReports(!permissions.READ_REPORT)}
        data-testid="reportsLink"
        data-text="reports"
        $isSelected={pathname.includes('reports')}
      >
        reports
      </StyledLinkElement>
      <StyledLinkElement
        $disabled={!permissions.READ_CREATIVES || baymaxAccountsOnly}
        $isSelected={pathname.includes('ad-gallery')}
        onClick={(): void => {
          if (!baymaxAccountsOnly) {
            handleClickToAdGallery(!permissions.READ_CREATIVES);
          }
        }}
        data-testid="adGallery"
        data-text="ad gallery"
      >
        ad gallery
      </StyledLinkElement>
      <StyledLinkElement
        $disabled={false}
        onClick={(): void => handleClickToHamhub(LINKS.helpCenter)}
        data-text="help center"
      >
        Help Center
      </StyledLinkElement>
      <StyledLinkElement
        $disabled={false}
        onClick={(): void => handleClickToHamhub(LINKS.contactUs)}
        data-text="contact us"
      >
        Contact Us
      </StyledLinkElement>
    </NavMenu>
  );
};

export default BrunoMenu;
